







































import { Vue, Component, Prop } from "vue-property-decorator";
import MasterManagementPopupComponent from "@/components/common/parts/MasterManagementPopupComponent.vue";
import SystemManagementPopupComponent from "@/components/common/parts/SystemManagementPopupComponent.vue";
import NotificationPopupComponent from "@/components/common/parts/NotificationPopupComponent.vue";
import AccountPopupComponent from "@/components/common/parts/AccountPopupComponent.vue";
import EllipsisComponent from "@/components/common/parts/EllipsisComponent.vue";
import { getRoutePath, isAllowed } from "@/router/routes";
import { getPermission } from "@/typescript/lib/common/get_permission";
export { getPermission };

@Component({
  components: {
    MasterManagementPopupComponent,
    SystemManagementPopupComponent,
    NotificationPopupComponent,
    AccountPopupComponent,
    EllipsisComponent
  }
})
export default class HeaderComponent extends Vue {
  @Prop({
    default: true
  })
  dashboardLinkVisible?: boolean;
  isSystemManagement: boolean = false;
  isMasterManagement: boolean = false;

  created() {
    const permission = getPermission(this.$store.state.authInfo.authority);
    this.isSystemManagement = permission.isAdmin;
    if (permission.isAdmin || permission.isMatter || permission.isArea)
      this.isMasterManagement = true;
  }

  checkDisplay(): boolean {
    return isAllowed(this.$route.name as string, [
      "notifications-create-page",
      "passwords-edit-page",
      "dashboard-page"
    ]);
  }

  getRoutePath(pageName: string, params: {}): string {
    return getRoutePath(pageName, params);
  }
}
